module.exports = __webpack_public_path__ + "img/icon-preference.00cef0c4.svg";